<aside class="rail" [class.is-collapsed]="collapsed" aria-label="Available views">
  <header class="rail-head">
    @if (!collapsed) {
      <span class="rail-title">
        <span class="rail-title-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
            <path d="M12 3 2 8l10 5 10-5-10-5Zm-7.6 8.2L2 12.5l10 5 10-5-2.4-1.3L12 15.1l-7.6-3.9Zm0 4.3L2 16.8l10 5 10-5-2.4-1.3L12 19.4l-7.6-3.9Z"/>
          </svg>
        </span>
        <span>Available Views</span>
      </span>
    }
    <button
      type="button"
      class="rail-toggle"
      (click)="toggle()"
      [attr.aria-expanded]="!collapsed"
      [title]="collapsed ? 'Show available views' : 'Hide available views'"
    >
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        @if (collapsed) {
          <path d="m15 6-6 6 6 6"/>
        } @else {
          <path d="m9 6 6 6-6 6"/>
        }
      </svg>
    </button>
  </header>

  @if (collapsed) {
    <div class="rail-collapsed-body" (click)="toggle()" title="Show available views">
      <span class="rail-collapsed-label">Available Views</span>
    </div>
  } @else {
    <div class="rail-body">
      <div class="rail-section">Dashboards</div>

      @for (view of visibleViews; track trackBySlug($index, view)) {
        <button type="button" class="view-card" (click)="openView(view.slug)" [title]="'Open ' + view.name">
          <span class="view-card-head">
            <span class="view-card-name">{{ view.name }}</span>
            <svg class="view-card-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6"/>
            </svg>
          </span>

          <span class="view-glyph" [attr.data-glyph]="view.glyph" aria-hidden="true">
            @switch (view.glyph) {
              @case ('bubble') {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <g class="g-accent">
                    <circle cx="22" cy="26" r="6"/><circle cx="34" cy="18" r="4"/><circle cx="40" cy="30" r="9"/>
                    <circle cx="27" cy="38" r="5"/><circle cx="52" cy="22" r="4"/><circle cx="98" cy="36" r="10"/>
                  </g>
                </svg>
              }
              @case ('bar') {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <g class="g-primary">
                    <rect x="18" y="46" width="16" height="4" rx="1"/><rect x="52" y="36" width="16" height="14" rx="1"/><rect x="86" y="8" width="16" height="42" rx="1"/>
                  </g>
                </svg>
              }
              @case ('hbar') {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <g class="g-primary">
                    <rect x="8" y="6" width="6" height="7" rx="1"/><rect x="8" y="16" width="4" height="7" rx="1"/>
                    <rect x="8" y="26" width="22" height="7" rx="1"/><rect x="8" y="36" width="100" height="7" rx="1"/>
                    <rect x="8" y="46" width="4" height="7" rx="1"/>
                  </g>
                </svg>
              }
              @case ('line') {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <polyline class="g-line" points="6,44 20,14 34,40 48,10 62,42 76,34 90,20 104,46 116,30"/>
                </svg>
              }
              @case ('table') {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <g class="g-primary">
                    <rect x="8" y="6" width="104" height="9" rx="2"/>
                  </g>
                  <g class="g-muted">
                    <rect x="8" y="19" width="104" height="7" rx="1"/><rect x="8" y="30" width="104" height="7" rx="1"/>
                    <rect x="8" y="41" width="104" height="7" rx="1"/>
                  </g>
                </svg>
              }
              @case ('kpi') {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <g class="g-muted">
                    <rect x="8" y="8" width="48" height="18" rx="4"/><rect x="64" y="8" width="48" height="18" rx="4"/>
                    <rect x="8" y="32" width="48" height="18" rx="4"/><rect x="64" y="32" width="48" height="18" rx="4"/>
                  </g>
                  <g class="g-primary">
                    <rect x="8" y="8" width="3" height="18" rx="1"/><rect x="64" y="8" width="3" height="18" rx="1"/>
                    <rect x="8" y="32" width="3" height="18" rx="1"/><rect x="64" y="32" width="3" height="18" rx="1"/>
                  </g>
                </svg>
              }
              @default {
                <svg viewBox="0 0 120 56" preserveAspectRatio="xMidYMid meet">
                  <g class="g-muted">
                    <rect x="8" y="6" width="50" height="20" rx="3"/><rect x="62" y="6" width="50" height="20" rx="3"/>
                    <rect x="8" y="30" width="104" height="20" rx="3"/>
                  </g>
                </svg>
              }
            }
          </span>
        </button>
      }

      @if (!visibleViews.length) {
        <div class="rail-empty">No other published dashboards yet.</div>
      }
    </div>
  }
</aside>
